import { useEffect } from "react";
import { DataTable, EmptyRow, Prompt, Screen, type Column, LoadError } from "../components/primitives";
import { useConsoleStore } from "../stores/consoleStore";
import { useUiStore } from "../stores/uiStore";
import type { EmbedderProfile } from "../types/domain";
import css from "./screens.module.css";

const COLUMNS: Column[] = [
  { key: "name", label: "profile", width: "1.6fr" },
  { key: "provider", label: "provider", width: "1.2fr" },
  { key: "dims", label: "dims", width: "0.7fr" },
  { key: "qp", label: "query_prefix", width: "1.4fr" },
  { key: "dp", label: "doc_prefix", width: "1.4fr" },
];

export default function Embedders() {
  const openDetail = useUiStore((s) => s.openDetail);
  const profiles = useConsoleStore((s) => s.profiles);
  const loadError = useConsoleStore((s) => s.errors.profiles);
  const load = useConsoleStore((s) => s.loadProfiles);

  useEffect(() => {
    void load();
  }, [load]);

  return (
    <Screen>
      <Prompt command="vf embedder-profiles ls" comment="# GET /v1/embedder-profiles" />
      <LoadError message={loadError} />

      <DataTable<EmbedderProfile>
        fontSize="12.5px"
        columns={COLUMNS}
        rows={profiles}
        rowKey={(p) => p.name}
        onRowClick={(p) => openDetail("profile", p.name)}
        empty={
          <EmptyRow
            title="no embedder profiles"
            body="Profiles are configured at server startup. A deployment with none can still serve BM25-only namespaces."
          />
        }
        note="// profiles are fixed at server startup — immutable catalog recipes; a new model/dims is a new profile + rebuild"
        renderCell={(p, key) => {
          switch (key) {
            case "name":
              return (
                <span style={{ color: "var(--vf-text)" }}>
                  {p.name}{" "}
                  {p.isDefault ? <span className={css.defaultChip}>default</span> : null}
                </span>
              );
            case "provider":
              return <span style={{ color: "var(--vf-sec)" }}>{p.provider}</span>;
            case "dims":
              return <span style={{ color: "var(--vf-acc)" }}>{p.dims}d</span>;
            case "qp":
              return <span style={{ color: "var(--vf-ok)" }}>{p.queryPrefix}</span>;
            case "dp":
              return <span style={{ color: "var(--vf-ok)" }}>{p.documentPrefix}</span>;
            default:
              return null;
          }
        }}
      />
    </Screen>
  );
}
